<script setup lang="ts">
defineProps<{
  border?: boolean;
}>();
</script>
<template>
  <div
    class="mt-4 flex flex-col gap-4"
    :class="{ '!mt-10 border-t pt-3': border }"
  >
    <h3 class="flex items-center gap-2">
      <span
        class="grid size-8 place-items-center rounded-full border font-bold text-black"
      >
        <slot name="number"></slot>
      </span>
      <span class="text-base font-bold leading-tight text-black">
        <slot name="header"></slot>
      </span>
    </h3>
    <div class="flex flex-col gap-4 pb-4">
      <slot name="default"></slot>
    </div>
  </div>
</template>
